import React from 'react';
import styles from './chatSidebar.scss';
import storeManager from '../../store/StoreManager';
import sessionActions from '../../actions/SessionActions';
import { t } from '../../services/i18nService';

const CloseSidebarButton = () => {
    const store = storeManager.getStore();
    const closeSidebar = () => {
        store.dispatch(sessionActions.setChatSidebarOpen(false));
    };

    return (<button
        className={styles.headerButton}
        aria-label={t('header.closeChatButtonLabel')}
        onClick={closeSidebar}
    >
        <i className="fa fa-close fa-3" aria-hidden="true" />
    </button>);
};

export default CloseSidebarButton;
